import classNames from "classnames";
import React from "react";

import { Link } from "../common/Link";
import { IFormHelpLink } from "../models/formFields.interfaces";
import { AbstractFormComponent } from "./AbstractFormComponent";

// TODO(ssr, LEVEL 2 out of 10): Migrate to functional component
// Complexity: Very simple component that renders help text as a link. Only overrides
// buildHelpText() method. No state, lifecycle methods, or complex logic.
// Migration: Convert to functional component that uses FormFieldWrapper (created from migrated
// AbstractFormComponent). Render <Link> inside help text container with classNames. Can become a
// simple functional component once AbstractFormComponent is migrated.
export class FormHelpLink extends AbstractFormComponent<
    IFormHelpLink,
    Record<string, never>
> {
    protected buildHelpText(): React.JSX.Element {
        const helpTextClasses = classNames({
            "form__help-text": true,
            [this.props.helpTextClass || ""]: !!this.props.helpTextClass,
        });

        return (
            <p className={helpTextClasses}>
                <Link
                    href={this.props.href}
                    target={this.props.target || "_top"}
                >
                    {this.props.helpText}
                </Link>
            </p>
        );
    }
}
